// src/pages/PurchasePolicy.jsx
import React from 'react';
import Navbar from '../components/LandingPage-main/Navbar';
import Footer from '../components/PlumPlusDash/Footer';

const PurchasePolicy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="mt-[72px] flex-grow">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <div className="bg-white rounded-lg shadow-sm p-6 sm:p-10">
            <h1 className="text-3xl font-semibold mb-6 text-gray-800 border-b pb-3">
              Politique d'Achat
            </h1>
            
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p className="text-base sm:text-lg">
                Vous êtes sur la page "Politique d'achat" de clicdroit.info. 
                Comme il s'agit de <span className="font-medium">contenu numérique téléchargeable</span>, 
                nous tenons à souligner qu'il n'existe 
                <span className="font-medium"> aucun remboursement possible</span> après l'achat.
              </p>
              
              <div className="bg-blue-50 p-5 rounded-md border-l-4 border-blue-500">
                <h2 className="font-medium text-lg text-gray-800 mb-2">Pourquoi ?</h2>
                <p>
                  Dès lors que vous accédez à notre contenu, 
                  vous bénéficiez immédiatement de la valeur intégrale de nos guides, checklists 
                  et autres ressources numériques. Il est donc impossible de "rendre" un 
                  document déjà téléchargé ou consulté.
                </p>
              </div>
              
              <p className="text-base sm:text-lg">
                Nous vous remercions pour votre compréhension. Pour toutes questions,
                <a href="/contact" className="text-blue-600 hover:text-blue-800 ml-1 underline focus:ring-2 focus:ring-blue-500 focus:outline-none">
                  contactez-nous ici
                </a>.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PurchasePolicy;
